import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tab';
import mediator from './mediator';

export default function () {
  const [, anchor] = location.hash.split('#');

  if (anchor) {
    const $this = $(`[id*='${anchor}']`);

    if ($this && $this.hasClass('tab-item')) {
      const mobileSelect = $this.parent().siblings('.tabs-heavy-select').find('select');
      const value = $this.attr('data-tab-label');

      $this.tab('show');

      if (mobileSelect.length) mobileSelect.val(value);
    }
  }

  $(document).on('show.bs.tab', (e) => {
    const $this = $(e.target);
    const $tabsDropdown = $this.parent().siblings('.tabs-heavy-select').find('select');
    $tabsDropdown.trigger('update', e.target);
  });

  $('.tabs-heavy').siblings('.tabs-heavy-select').find('select').on({
    update: (e, tab) => {
      const relatedTab = tab.dataset.tabLabel;
      $(e.target).val(relatedTab);
    },
    change: (e) => {
      const $this = $(e.target);
      const tab = $this.val();
      const $el = $this.closest('.tabs-heavy-select').siblings('.tabs-heavy').find(`[data-tab-label=${tab}]`);
      $el.tab('show');
      $this.trigger('update', $el);
    }
  });

  (function ($) {
    $.fn.cignaTabs = function () {
      return this.each(function () {
        const self = this;
        const $self = $(this);

        const defaults = {
          tabs: $self.find('.nav-tabs'),
          leftArrow: $self.siblings('.arrow-left'),
          rightArrow: $self.siblings('.arrow-right')
        };

        let incWidth = 0;

        self.settings = {};

        self.init = function () {
          self.settings = $.extend({}, defaults);

          const { leftArrow, rightArrow } = self.settings;

          self.checkArrowHide();

          rightArrow.click(() => {
            self.right($self.find('.nav-tabs .js-tab-target'));
          });

          leftArrow.click(() => {
            self.left($self.find('.nav-tabs .js-tab-target'));
          });

          mediator.on('window:throttledResize', () => self.resize());

          mediator.trigger('window:throttledResize');
        };

        self.checkArrowHide = function () {
          const { leftArrow, rightArrow, tabs } = self.settings;
          const tabContainerWidth = $self.parent().width();
          const tabsWidth = tabs.width();

          if (!incWidth || incWidth <= 12) {
            leftArrow.hide();
            incWidth = 0;
          } else {
            leftArrow.show();
          }

          if (tabContainerWidth + incWidth >= tabsWidth) {
            rightArrow.hide();
          } else {
            rightArrow.show();
          }
        };

        self.right = function (currTab) {
          let currTabWidth;

          if (currTab.next().length) {
            currTab.next().addClass('js-tab-target');
            currTab.removeClass('js-tab-target');
            currTabWidth = Math.round(currTab.outerWidth());
          }

          incWidth += currTabWidth;
          $self.animate({ marginLeft: `-=${currTabWidth}` });
          self.checkArrowHide();
        };

        self.left = function (currTab) {
          let currTabWidth;

          if (currTab.prev().length) {
            currTab.prev().addClass('js-tab-target');
            currTab.removeClass('js-tab-target');
            currTabWidth = Math.round(currTab.prev().outerWidth());
          }

          incWidth -= currTabWidth;
          $self.animate({ marginLeft: `+=${currTabWidth}` });
          self.checkArrowHide();
        };

        self.resize = function () {
          const { leftArrow, rightArrow, tabs } = self.settings;
          const arrows = $self.siblings('.arrow');
          const tabsWrapper = $self.parent();
          const tabItems = tabs.children();
          let tabsContainerWidth;
          let tabsWidth;

          if (self.tabScrollInactive()) {
            self.addTabScroll();
            tabsWidth = tabs.width();
            tabsContainerWidth = tabsWrapper.width();
            self.removeTabScroll();
          } else {
            tabsWidth = tabs.width();
            tabsContainerWidth = tabsWrapper.width();
          }

          if (tabsContainerWidth >= tabsWidth) {
            arrows.hide();

            if (incWidth) {
              leftArrow.hide();
              $self.find('.js-tab-target').removeClass('js-tab-target');
              tabItems.first().addClass('js-tab-target');
              $self.animate({ marginLeft: `+=${incWidth}` });
              incWidth = 0;
            }

            self.removeTabScroll();
          } else {
            self.addTabScroll();

            arrows.show();

            if (!incWidth) leftArrow.hide();

            if (tabsContainerWidth + incWidth >= tabsWidth) rightArrow.hide();
          }
        };

        self.addTabScroll = function () {
          const { tabs } = self.settings;
          tabs.removeClass('js-scroll-inactive');
        };

        self.removeTabScroll = function () {
          const { tabs } = self.settings;
          tabs.addClass('js-scroll-inactive');
        };

        self.tabScrollInactive = function () {
          const { tabs } = self.settings;
          return tabs.hasClass('js-scroll-inactive');
        };

        self.init();
      });
    };
  }(jQuery));

  $('.tabs-container').cignaTabs();
}



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/tabs.js